<template>
  <v-tabs v-model="tabs">
    <v-tab> Geral </v-tab>

    <v-tab> Comunicações </v-tab>

    <v-tab> Transações </v-tab>

    <v-tab> Comprovantes </v-tab>

    <v-tab> Antifraude </v-tab>

    <v-tab> Lojas </v-tab>

    <v-tab> Histórico de listas restritivas </v-tab>

    <v-tab>Contas do cliente</v-tab>

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <analysis-table-form
          v-model="payload"
          child
        >
          <template #top>
            <user-wallet-content v-model="payload.id" />
            <user-pin-content v-model="pinInfo" />
          </template>
        </analysis-table-form>
      </v-tab-item>

      <v-tab-item>
        <user-communication-list v-model="payload.id" />
      </v-tab-item>

      <v-tab-item>
        <form-group class="ma-0 pa-0-">
          <v-row
            class="ma-1"
            justify="end"
          >
            <v-col cols="3">
              <user-transaction-filter />
            </v-col>
          </v-row>
          <user-statement-list v-model="payload.id" />
        </form-group>
      </v-tab-item>

      <v-tab-item>
        <user-receipts-content v-model="payload.id" />
      </v-tab-item>

      <v-tab-item>
        <user-anti-fraud-content v-model="payload" />
      </v-tab-item>

      <v-tab-item>
        <user-store-content v-model="payload.id" />
      </v-tab-item>

      <v-tab-item>
        <user-legal-search-history-list v-model="payload.cpfCnpj" />
      </v-tab-item>

      <v-tab-item>
        <client-bank-account
          v-model="payload.id"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>

<script>
import AnalysisTableForm from '@/app/modules/contacard/analysisTable/AnalysisTableForm.vue';
import UserCommunicationList from 'App/users/components/tables/UserCommunicationList.vue';
import UserStatementList from 'App/users/components/tables/UserStatementList.vue';
import UserReceiptsContent from 'App/users/components/contents/UserReceiptsContent.vue';
import RouterMixin from '@/app/arch/mixins/RouterMixin';
import UserAntiFraudContent from 'App/users/components/contents/UserAntiFraudContent.vue';
import UserStoreContent from 'App/users/components/contents/UserStoreContent.vue';
import UserLegalSearchHistoryList from 'App/users/components/tables/UserLegalSearchHistoryList.vue';
import UserPinContent from 'App/users/components/contents/UserPinContent.vue';
import UserWalletContent from 'App/users/components/contents/UserWalletContent.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import UserTransactionFilter from '../filters/UserTransactionFilter.vue';
import ClientBankAccount from '../list/ClientBankAccount.vue';

export default {
  name: 'ContaCardContent',
  components: {
    AnalysisTableForm,
    UserCommunicationList,
    UserStatementList,
    UserReceiptsContent,
    UserAntiFraudContent,
    UserStoreContent,
    UserLegalSearchHistoryList,
    UserPinContent,
    UserWalletContent,
    FormGroup,
    UserTransactionFilter,
    ClientBankAccount,
  },
  mixins: [RouterMixin],
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    pin: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    tabs: null,
  }),
  computed: {
    payload() {
      return this.value;
    },
    pinInfo() {
      return this.pin;
    },
  },
  watch: {
    tabs: {
      immediate: true,
      handler(tab) {
        if (typeof tab === 'number') {
          this.clearQueryParams();
        }
      },
    },
  },
};
</script>
